import React, {useEffect, useState, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {SVVRadioGroup} from "@komponentkassen/svv-form";
import {useApptekster} from "../../apptekst-context";
import InterfaceService from '../../interface/InterfaceService';
import {SVVSpinner} from "@komponentkassen/svv-spinner";
import api from "../../helpers/api";
import FormButtons from "../../components/FormButtons";
import { TjenesteTyper} from "../../types/tjenester";
import {SVVBodyText, SVVHeading} from "@komponentkassen/svv-text";

const Service = (props: {
  service: InterfaceService;
  setService: any;
  abort: any;
  nextUrl: string
  prevUrl?: string
  //kunTeori er true hvis man prøver å endre en booking som har serviceName="teori".
  //Både tung og lett teori har serviceName="Teori" i Ventus, så vi må håndtere dette i klienten.
  visKunTeori?: boolean
  avbrytUrl?: string
}) => {
  const t = useApptekster();
  const [services, setServices] = useState<InterfaceService[]>([]);
  const [valid, setValid] = useState(true);
  const navigate = useNavigate();
  const headingRef = useRef<HTMLHeadingElement | null>(null);
  
  useEffect(function () {
    api
      .get(`/api/Timebestilling/getservices`)
      .then((response) => {
        // Sett rekkefølgen med index i henhold til designet i Figma
        let servicesArray = response.data.map((s:InterfaceService) => {
          switch (s.serviceName.toLowerCase()) {
            case TjenesteTyper.teori:
              s.serviceName = t("timebestilling.lett-teori")
              s.forklaring = t("timebestilling.lett-teori-forklaring")
              s.index = 1
              break
            case TjenesteTyper.forerkort:
              s.serviceName = t("timebestilling.forerkort")
              s.forklaring = t("timebestilling.forerkort-forklaring")
              s.index = 2
              break
            case TjenesteTyper.registrering:
              s.serviceName = t("timebestilling.registrering")
              s.forklaring = t("timebestilling.registrering-forklaring")
              s.index = 3
              break
          }
          return s;
          // eslint-disable-next-line
        }).sort((a:InterfaceService, b:InterfaceService) => {
          if (a.index && b.index) {
            return a.index - b.index;
          }
        })
        
        if (props.visKunTeori) {
          setServices(servicesArray.filter((s: InterfaceService) => s.serviceName === t("timebestilling.lett-teori")))
        } else {
          setServices(servicesArray);
        }
      })
      .catch((error) => {
        // handle error
        console.log(error);
      });
    //Disable eslint fordi denne effecten skal kun kjøres én gang når komponenten mountes
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (headingRef?.current) {
      headingRef.current.focus()
    }
  }, [headingRef])
  
  const submit = (event: any) => {
    event.preventDefault();
    setValid(true);
    if (props.service.serviceId) {
      navigate(props.nextUrl);
    } else {
      setValid(false);
    }
  };

  const serviceChangeHandler = (event: any) => {
    if (!valid) {
      setValid(true);
    }
    
    if(event.target.value === "tung"){
      const s = {
        ...services.find((t) => t.serviceId.toString() === services[0].serviceId.toString()) || {},
        isTungKjoreToy: true
      }
      props.setService(s);
    } else {
      props.setService(
        services.find((t) => t.serviceId.toString() === event.target.value) || {},
      );
    }
  }

  return (
  <>
    <SVVHeading 
      level="h2"
      tabIndex={-1}
      marginBottom="xs"
      ref={headingRef}
    >
      {t("timebestilling.hva-bestille-til")}
    </SVVHeading>
    <SVVBodyText>
      {t("timebestilling.fyll-ut-felter")}
    </SVVBodyText>
    <form 
      className="skjemagruppe" 
      onSubmit={submit}
      noValidate
    >
      <div className="spacing-bottom--medium">
        {services.length === 0 &&
            <SVVSpinner>
              {t("timebestilling.henter-tjenester")}
            </SVVSpinner>
        }
        {services.length > 0 &&
            <SVVRadioGroup
              id="Section-select"
              legend={t("timebestilling.velg-tjeneste")}
              name={t("timebestilling.velg-tjeneste")}
              selected={props.service.isTungKjoreToy ? "tung" : props.service.serviceId}
              options={[
                {
                  text: t("timebestilling.tung-teori"),
                  value: "tung",
                  description: t("timebestilling.tung-teori-forklaring"),
                },
                ...services.map(s => ({
                  text: s.serviceName,
                  value: s.serviceId,
                  description: s.forklaring
                })),
              ]}
              errorMessage={!valid ? t("timebestilling.du-ma-velge-tjeneste") : ""}
              required
              direction="vertical"
              onChange={serviceChangeHandler}
            />
        }
      </div>
      
      <FormButtons
        submitText={t("timebestilling.neste")}
        cancelText={t("timebestilling.avbryt")}
        onCancel={props.abort}
        avbrytUrl={props.avbrytUrl}
      />
    </form>
    </>
  );
};

export default Service;